import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const words = ["Brand Identity", "Art Direction", "Rollout Strategy", "Merch & Packaging", "Social Worlds", "Web Experience"];

export const EditorialMarquee = () => (
  <section data-testid="marquee-section" className="bg-[#B5D5C5] py-8 md:py-10 overflow-hidden -rotate-1 scale-[1.02] my-4">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {words.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-serif-display italic text-4xl md:text-6xl text-[#2D1A13] px-8 md:px-14 whitespace-nowrap">
            {w}
          </span>
          <Asterisk size={34} className="text-[#2D1A13]/60 shrink-0" strokeWidth={1.4} />
        </span>
      ))}
    </Marquee>
  </section>
);
